var $dad545c909cfec2d$exports = {};
const $dad545c909cfec2d$var$userTab = document.querySelector("[data-userWeather]");
const $dad545c909cfec2d$var$searchTab = document.querySelector("[data-searchWeather]");
const $dad545c909cfec2d$var$userContainer = document.querySelector(".weather-container");
const $dad545c909cfec2d$var$grantAccessContainer = document.querySelector(".grant-location-container");
const $dad545c909cfec2d$var$searchForm = document.querySelector("[data-searchForm]");
const $dad545c909cfec2d$var$loadingScreen = document.querySelector(".loading-container");
const $dad545c909cfec2d$var$userInfoContainer = document.querySelector(".user-info-container");
const $dad545c909cfec2d$var$errContainer = document.querySelector(".err-container");
//initially vairables need????
let $dad545c909cfec2d$var$oldTab = $dad545c909cfec2d$var$userTab;
const $dad545c909cfec2d$var$API_KEY = "d1845658f92b31c64bd94f06f7188c9c";
$dad545c909cfec2d$var$oldTab.classList.add("current-tab");
$dad545c909cfec2d$var$getfromSessionStorage();
function $dad545c909cfec2d$var$switchTab(newTab) {
    if (newTab != $dad545c909cfec2d$var$oldTab) {
        $dad545c909cfec2d$var$oldTab.classList.remove("current-tab");
        $dad545c909cfec2d$var$oldTab = newTab;
        $dad545c909cfec2d$var$oldTab.classList.add("current-tab");
        if ($dad545c909cfec2d$var$errContainer.classList.contains("active")) $dad545c909cfec2d$var$errContainer.classList.remove("active");
        if (!$dad545c909cfec2d$var$searchForm.classList.contains("active")) {
            //kya search form wala container is invisible, if yes then make it visible
            $dad545c909cfec2d$var$userInfoContainer.classList.remove("active");
            $dad545c909cfec2d$var$grantAccessContainer.classList.remove("active");
            $dad545c909cfec2d$var$searchForm.classList.add("active");
        } else {
            //main pehle search wale tab pr tha, ab your weather tab visible karna h 
            $dad545c909cfec2d$var$searchForm.classList.remove("active");
            $dad545c909cfec2d$var$userInfoContainer.classList.remove("active");
            //ab main your weather tab me aagya hu, toh weather bhi display karna poadega, so let's check local storage first
            //for coordinates, if we haved saved them there.
            $dad545c909cfec2d$var$getfromSessionStorage();
        }
    }
}
$dad545c909cfec2d$var$userTab.addEventListener("click", ()=>{
    //pass clicked tab as input paramter
    $dad545c909cfec2d$var$switchTab($dad545c909cfec2d$var$userTab);
});
$dad545c909cfec2d$var$searchTab.addEventListener("click", ()=>{
    //pass clicked tab as input paramter
    $dad545c909cfec2d$var$switchTab($dad545c909cfec2d$var$searchTab);
});
//check if cordinates are already present in session storage
function $dad545c909cfec2d$var$getfromSessionStorage() {
    const localCoordinates = sessionStorage.getItem("user-coordinates");
    if (!localCoordinates) //agar local coordinates nahi mile
    $dad545c909cfec2d$var$grantAccessContainer.classList.add("active");
    else {
        const coordinates = JSON.parse(localCoordinates);
        $dad545c909cfec2d$var$fetchUserWeatherInfo(coordinates);
    }
}
async function $dad545c909cfec2d$var$fetchUserWeatherInfo(coordinates) {
    const { lat: lat, lon: lon } = coordinates;
    // make grantcontainer invisible
    $dad545c909cfec2d$var$grantAccessContainer.classList.remove("active");
    //make loader visible
    $dad545c909cfec2d$var$loadingScreen.classList.add("active");
    //API CALL
    try {
        const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${$dad545c909cfec2d$var$API_KEY}&units=metric`);
        const data = await response.json();
        $dad545c909cfec2d$var$loadingScreen.classList.remove("active");
        $dad545c909cfec2d$var$userInfoContainer.classList.add("active");
        $dad545c909cfec2d$var$renderWeatherInfo(data);
    } catch (err) {
        $dad545c909cfec2d$var$loadingScreen.classList.remove("active");
    //HW
    }
}
function $dad545c909cfec2d$var$renderWeatherInfo(weatherInfo) {
    //fistly, we have to fethc the elements 
    const cityName = document.querySelector("[data-cityName]");
    const countryIcon = document.querySelector("[data-countryIcon]");
    const desc = document.querySelector("[data-weatherDesc]");
    const weatherIcon = document.querySelector("[data-weatherIcon]");
    const temp = document.querySelector("[data-temp]");
    const windspeed = document.querySelector("[data-windspeed]");
    const humidity = document.querySelector("[data-humidity]");
    const cloudiness = document.querySelector("[data-cloudiness]");
    console.log(weatherInfo);
    //fetch values from weatherINfo object and put it UI elements
    cityName.innerText = weatherInfo?.name;
    countryIcon.src = `https://flagcdn.com/144x108/${weatherInfo?.sys?.country.toLowerCase()}.png`;
    desc.innerText = weatherInfo?.weather?.[0]?.description;
    weatherIcon.src = `http://openweathermap.org/img/w/${weatherInfo?.weather?.[0]?.icon}.png`;
    temp.innerText = `${weatherInfo?.main?.temp} \xb0C`;
    windspeed.innerText = `${weatherInfo?.wind?.speed} m/s`;
    humidity.innerText = `${weatherInfo?.main?.humidity}%`;
    cloudiness.innerText = `${weatherInfo?.clouds?.all}%`;
}
function $dad545c909cfec2d$var$getLocation() {
    if (navigator.geolocation) navigator.geolocation.getCurrentPosition($dad545c909cfec2d$var$showPosition, $dad545c909cfec2d$var$error);
}
function $dad545c909cfec2d$var$error(err) {
    if (err.code == 1) alert("User has denied access to location ,please enable location");
    else console.log("some error in geolocation", err);
}
function $dad545c909cfec2d$var$showPosition(position) {
    console.log("position", position);
    const userCoordinates = {
        lat: position.coords.latitude,
        lon: position.coords.longitude
    };
    sessionStorage.setItem("user-coordinates", JSON.stringify(userCoordinates));
    $dad545c909cfec2d$var$fetchUserWeatherInfo(userCoordinates);
}
const $dad545c909cfec2d$var$grantAccessButton = document.querySelector("[data-grantAccess]");
$dad545c909cfec2d$var$grantAccessButton.addEventListener("click", $dad545c909cfec2d$var$getLocation);
const $dad545c909cfec2d$var$searchInput = document.querySelector("[data-searchInput]");
$dad545c909cfec2d$var$searchForm.addEventListener("submit", (e)=>{
    e.preventDefault();
    let cityName = $dad545c909cfec2d$var$searchInput.value;
    if (cityName === "") return;
    else $dad545c909cfec2d$var$fetchSearchWeatherInfo(cityName);
});
async function $dad545c909cfec2d$var$fetchSearchWeatherInfo(city) {
    $dad545c909cfec2d$var$loadingScreen.classList.add("active");
    $dad545c909cfec2d$var$userInfoContainer.classList.remove("active");
    $dad545c909cfec2d$var$grantAccessContainer.classList.remove("active");
    if ($dad545c909cfec2d$var$errContainer.classList.contains("active")) $dad545c909cfec2d$var$errContainer.classList.remove("active");
    try {
        const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${$dad545c909cfec2d$var$API_KEY}&units=metric`);
        const data = await response.json();
        if (data.cod === "404") {
            $dad545c909cfec2d$var$loadingScreen.classList.remove("active");
            $dad545c909cfec2d$var$errContainer.classList.add("active");
        } else {
            $dad545c909cfec2d$var$loadingScreen.classList.remove("active");
            $dad545c909cfec2d$var$userInfoContainer.classList.add("active");
            $dad545c909cfec2d$var$renderWeatherInfo(data);
        }
    } catch (err) {
        console.log(err);
    }
}


//# sourceMappingURL=index.ecbc661d.js.map
